module.exports = __webpack_public_path__ + "static/meditation-app-cover-57ec1f189c6d83ac69ec7ec22d098c3b.png";